var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section grid-wrapper" },
    [
      _c("cargo-ag-grid", {
        style: "min-height: " + _vm.gridHeight + ";",
        attrs: {
          "config-module": "190809",
          "show-side-bar": false,
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData,
          "auto-fit-content": false
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }